import { PayloadAction } from '../../../store.model';
import { createFilteredQuotesLookup } from '../function/create-filtered-quotes-lookup.function';
import { filterQuotesByKeyword } from '../function/filter-quotes-by-keyword.function';
import { filterQuotesByParticipants } from '../function/filter-quotes-by-participants.function';
import { filterQuotesByTimeRange } from '../function/filter-quotes-by-time-range.function';
import { ActionType } from '../transcript-dialog.action';
import { TranscriptDialogState } from '../transcript-dialog.state';

import { FilterQuotes } from './filter-quotes.action';

export function filterQuotesReducer(
    state: TranscriptDialogState,
    action: PayloadAction<
        ActionType.COACHING_DETAIL__TD__FILTER_QUOTES,
        FilterQuotes
    >,
): TranscriptDialogState {
    try {
        let nextFiltered = filterQuotesByParticipants(
            action.payload.opts.participants,
            state.transcript.quotes,
        );
        nextFiltered = filterQuotesByKeyword(
            action.payload.opts.keyword,
            nextFiltered,
        );
        nextFiltered = filterQuotesByTimeRange(
            action.payload.opts.timeRange,
            state.transcript.quotes?.[0]?.endTime,
            nextFiltered,
        );

        const { lookup: nextLookup, all: nextAllQuotesAreSelected } =
            createFilteredQuotesLookup(nextFiltered, state.selectedQuotes);

        return {
            ...state,
            filteredQuotes: nextFiltered,
            filterOpts: action.payload.opts,
            filteredQuotesSelectedLookup: nextLookup,
            allQuotesAreSelected: nextAllQuotesAreSelected,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
